import { ScrollView } from 'react-native'
import { useTranslation } from 'react-i18next'

import { getPaymentMethod } from '@/utils/payment'
import DescriptionListItem from '@/components/DescriptionListItem'
import { useImageViewer } from '@/components/ImageViewer'

function PaymentSectionDetail({ data, type }: { data: Record<string, any>; type: 'buy' | 'sell' }) {
  const { t } = useTranslation()
  const paymentMethod = getPaymentMethod(data)
  const { setSource, setType } = useImageViewer()
  return (
    <ScrollView>
      <DescriptionListItem label={t(type === 'buy' ? 'orders:paymentMethod' : 'orders:paymentMethods')} hasBorderTop={true}>
        {t(`payment:${paymentMethod}`)}
      </DescriptionListItem>
      {paymentMethod === 'bank' && (
        <>
          <DescriptionListItem label={t('orders:name')} canCopy={true}>
            {data[paymentMethod]?.name || ''}
          </DescriptionListItem>
          <DescriptionListItem label={t('orders:bankName')} canCopy={true}>
            {data[paymentMethod]?.bankName || ''}
          </DescriptionListItem>
          <DescriptionListItem label={t('orders:bankBranch')} canCopy={true}>
            {data[paymentMethod]?.branchName || ''}
          </DescriptionListItem>
          <DescriptionListItem label={t('orders:bankAccountNumber')} canCopy={true} hasBorderBottom={true}>
            {data[paymentMethod]?.account || ''}
          </DescriptionListItem>
        </>
      )}
      {(paymentMethod === 'alipay' || paymentMethod === 'wechat' || paymentMethod === 'qq') && (
        <>
          <DescriptionListItem label={t('orders:name')} canCopy={true}>
            {data[paymentMethod]?.name || ''}
          </DescriptionListItem>
          <DescriptionListItem label={t('orders:account', { method: t(`payment:${paymentMethod}`) })} canCopy={true}>
            {data[paymentMethod]?.account || ''}
          </DescriptionListItem>
          <DescriptionListItem
            label={t('orders:receivingCode', { method: t(`payment:${paymentMethod}`) })}
            hasBorderBottom={true}
            onOpenQrCode={() => {
              setType('qrcode')
              setSource(data[paymentMethod]?.url || '')
            }}
          >
            {''}
          </DescriptionListItem>
        </>
      )}
      {paymentMethod === 'ermb' && (
        <>
          <DescriptionListItem label={t('orders:name')} canCopy={true}>
            {data[paymentMethod]?.name || ''}
          </DescriptionListItem>
          <DescriptionListItem
            label={t('orders:account', { method: t(`payment:${paymentMethod}`) })}
            canCopy={true}
            hasBorderBottom={true}
          >
            {data[paymentMethod]?.account || ''}
          </DescriptionListItem>
        </>
      )}
    </ScrollView>
  )
}

export default PaymentSectionDetail
